import { createFileRoute } from '@tanstack/react-router'

// B-new-10010 (S2): /{locale}/checkout/return/{success|pending|cancelled|failed|region}.
// Reachable with an id only: Stripe's success_url carries `session_id`, the
// cancel_url carries `ref`. The lazy component rejects anything else.
export const Route = createFileRoute('/$locale/checkout/return/$state')({
  ssr: false, // authenticated, no SEO
  validateSearch: (s: Record<string, unknown>) => ({
    session_id: typeof s.session_id === 'string' && s.session_id ? s.session_id : undefined,
    ref: typeof s.ref === 'string' && s.ref ? s.ref : undefined,
  }),
})
